module.exports = {
    BASE_URL: 'https://bestinbd.com/projects/web/2420ASW/api/',
    MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s'
}